import { Space, Typography } from "antd";
import { useMemo } from "react";
import { CustomerOrderVehicleItemInfo } from "../../../../../model/OrderManagement/CustomerOrder";
import color from "../../../../../theme/color";
import { ItemDescriptions } from "../../../Description/Item";
import { CustomDescriptions } from "../../../Description/index.styled";
import { VehicleRegistStatusTag } from "../../Tags/VehicleRegistStatus";
import { getModelAllYr } from "../../utils/modelYear";
import { Section } from "../index.styled";

interface RepairVehicleInfoFormProps {
  dataSource?: CustomerOrderVehicleItemInfo;
}

/**
 * 매장주문 > 고객 정보 - 차량정보
 * @TODO 외부채널 기본차량정보..
 * @param param0
 * @returns
 */
export const RepairVehicleInfoForm: React.FC<RepairVehicleInfoFormProps> = ({
  dataSource,
}) => {
  /**
   * 타이어 전륜 후륜 같은지 체크
   */
  const oneSize = useMemo(
    () => dataSource?.frontTire?.trim() === dataSource?.rearTire?.trim(),
    [dataSource]
  );

  /**
   * 제품상세페이지- 호환모델 연도 표기
   */
  const modelYears = useMemo(() => getModelAllYr(dataSource), [dataSource]);

  /**
   * 차량정보
   * 차량 번호 != 제품 상세페이지
   * 차량 정보 != 제품 상세페이지
   * 차량 브랜드
   * 모델 (추가됨) = 제품 상세페이지
   * 상세모델 (추가됨) = 제품 상세페이지
   * 배터리 규격 != 제품 상세페이지, 담당자 수기입력
   * 타이어 사이즈 (전/후륜) != 제품 상세페이지, 담당자 수기입력
   * 엔진오일 용량 != 담당자 수기입력, 담당자 수기입력
   * 엔진오일 추천점도 != 담당자 수기입력, 담당자 수기입력
   */
  return (
    <Section>
      <ItemDescriptions
        title={<Typography.Title level={5}>차량정보</Typography.Title>}
        layout="horizontal"
        labelStyle={{
          width: 120,
          fontWeight: 500,
        }}
        className="info"
      >
        <CustomDescriptions.Item label="차량 등록 방법">
          <VehicleRegistStatusTag
            value={dataSource?.vehicleRegistrationType || "UNKNOWN"}
          />
        </CustomDescriptions.Item>
        <CustomDescriptions.Item label="차량번호">
          {dataSource?.vehicleNumber || "-"}
        </CustomDescriptions.Item>
        <CustomDescriptions.Item label="차량 브랜드">
          {dataSource?.brand || "-"}
        </CustomDescriptions.Item>
        <CustomDescriptions.Item label="브랜드 타입">
          {dataSource?.isDomestic !== undefined
            ? dataSource?.isDomestic
              ? "국산"
              : "수입"
            : "-"}
        </CustomDescriptions.Item>
        <CustomDescriptions.Item label="차종">
          <Space size={4} align="center" wrap>
            <Typography.Text>
              {dataSource?.vehicleDetailGroupName ||
                dataSource?.displayVehicleModel ||
                dataSource?.model ||
                "-"}
            </Typography.Text>
            {modelYears && (
              <Typography.Text style={{ color: color.gray5, fontSize: 13 }}>
                {modelYears}
              </Typography.Text>
            )}
          </Space>
        </CustomDescriptions.Item>
        {!["SELECT", "ADMIN"].includes(
          dataSource?.vehicleRegistrationType || ""
        ) && (
          <CustomDescriptions.Item label="상세모델">
            <Typography.Text>{dataSource?.trim || "-"}</Typography.Text>
          </CustomDescriptions.Item>
        )}
        {!["SELECT", "ADMIN"].includes(
          dataSource?.vehicleRegistrationType || ""
        ) && (
          <CustomDescriptions.Item label="배터리 규격">
            {dataSource?.batteryModel || "-"}
          </CustomDescriptions.Item>
        )}
        {!["SELECT", "ADMIN"].includes(
          dataSource?.vehicleRegistrationType || ""
        ) && (
          <>
            {oneSize && (
              <CustomDescriptions.Item label="타이어 사이즈">
                {dataSource?.frontTire || "-"}
              </CustomDescriptions.Item>
            )}
            {!oneSize && (
              <>
                <CustomDescriptions.Item label="타이어 사이즈 (전륜)">
                  {dataSource?.frontTire || "-"}
                </CustomDescriptions.Item>
                <CustomDescriptions.Item label="타이어 사이즈 (후륜)">
                  {dataSource?.rearTire || "-"}
                </CustomDescriptions.Item>
              </>
            )}
          </>
        )}
        {!["ADMIN"].includes(dataSource?.vehicleRegistrationType || "") && (
          <CustomDescriptions.Item label="엔진오일 용량">
            {(dataSource?.engineOilLiter && (
              <>{dataSource?.engineOilLiter}L</>
            )) ||
              "-"}
          </CustomDescriptions.Item>
        )}
        {!["ADMIN"].includes(dataSource?.vehicleRegistrationType || "") && (
          <CustomDescriptions.Item label="엔진오일 추천점도">
            {dataSource?.engineOilViscosity || "-"}
          </CustomDescriptions.Item>
        )}
      </ItemDescriptions>
    </Section>
  );
};
